// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  Grid,
  Badge
} from '../../'


export const MessageVariableChooser = ({ label, variables, onClick, className }) => (
  <div className={className}>
    {label &&
      <div className='slds-text-body_small'>
        {label}
      </div>
    }
    {/*<VariableSelector*/}
    <Grid
      items={variables.map(variable => (
        <Badge
          inverse={true}
          minWidth={100}
          onClick={() => onClick(variable)}
          className='clickable slds-p-left_x-small'>
          {variable}
        </Badge>
      ))}
      itemSpacing='xx-small'
      rowClassName='slds-m-bottom_large'
      className='slds-p-top_small'
    />
  </div>
)

MessageVariableChooser.propTypes = {
  label: PropTypes.string,
  variables: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
}

MessageVariableChooser.defaultProps = {
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/messageplus/message-variable-chooser/index.js